import { defineModel } from "../define-model";
import type { Platform } from "./strategy";

export type CompetitorProfileStats = {
	followers?: number;
	following?: number;
	posts?: number;
	avgEngagement?: number;
	displayName?: string;
	avatarUrl?: string;
	sampleSize?: number;
	postsPerWeek?: number;
	avgLikes?: number;
	avgComments?: number;
	avgViews?: number;
	engagementRate?: number;
	formats?: Record<string, number>;
	topHashtags?: string[];
	bestDays?: string[];
	scrape?: {
		id: string;
		status: "queued" | "running" | "ready" | "failed";
		at: string;
		error?: string;
	};
};

export type CompetitorProfile = {
	id: string;
	workspaceId: string;
	projectId: string;
	competitorId: string;
	platform: Platform;
	handle: string;
	url: string;
	stats: CompetitorProfileStats;
	lastScrapedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		competitorProfile: CompetitorProfile;
	}
}

export const model = defineModel({
	name: "competitorProfile",
	load: "eager",
	indexes: ["competitorId", "projectId"],
	defaults: ({ workspaceId, now }) => ({
		workspaceId,
		url: "",
		stats: {},
		lastScrapedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => a.platform.localeCompare(b.platform) || a.createdAt.localeCompare(b.createdAt),
});
